import {
    DisassociateCostCenterModal,
    DisassociateCostCenterModel,
    EmployeeNodeModel,
} from '../../models';

export const DISASSOCIATE_COST_CENTER_MODAL_EMPTY: DisassociateCostCenterModal = {
    startDate: '',
    endDate: '',
    employee: {} as EmployeeNodeModel[],
    listToDelete: {} as DisassociateCostCenterModel[],
};
